<!--
 * @Author: your name
 * @Date: 2020-07-15 18:00:26
 * @LastEditTime: 2020-10-10 11:23:32
 * @LastEditors: Please set LastEditors
 * @Description: 试卷列表
 * @FilePath: \vue-gaokao-ebook\src\views\home\exam\placement.vue
--> 
<template>
  <div class="paper_list_content">
    <Header></Header>

    <div class="container" v-loading ="paperLoading">
      <div class="el_header">
        <div class="bread">
          <router-link class="first" to="/" tag="span">首页/</router-link>
          <router-link to="/home" tag="span">专家测评/</router-link>
          <span>专题强化</span>
        </div>

        <div class="tabs">
          <div class="first_tab">选择学科 |</div>
          <div
            v-for="(value,key,index) in subjects"
            :key="index"
            :class="[tab == key ? 'selected_tab' : 'tab']"
            @click="clickTab(key)"
          >{{value}}</div>
        </div>
      </div>
      <div class="left">
        <div class="bar">专题强化</div>
        <div class="tree">
          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" :indent="14">
            
          </el-tree>
        </div>
      </div>
      <div class="main" >
        <div v-if="pagination.list != undefined && pagination.list.length > 0">
          <div
            v-for="(item,index) in pagination.list"
            @mouseover="mouseOver(item.id)"
            @mouseout="mouseOut"
            :key="index"
            class="test_paper"
            @click="toPaper(item.id)"
          >
            <div
              :class="mouseoverId==item.id ?'mouseover_paper_number':'mouseout_paper_number'"
            >{{ index + (current_page - 1) * 5 + 1 >= 10 ? index + (current_page - 1) * 5 + 1 : `0${index + (current_page-1) * 5 + 1 }` }}</div>
            <div class="middle">
              <div class="paper_name">{{item.pname}}</div>

              <div class="paper_info">
                <div class="paper_orgin">
                  <span class="text">试卷来源 :</span>
                  <span class="source">{{item.source}}</span>
                </div>

                <div>
                  <span class="text">题目数量 :</span>
                  <span class="value">{{item.questionCount}}</span>
                </div>

                <div>
                  <span class="text">总分 :</span>
                  <span class="value">{{item.totalScore}}</span>
                </div>

                <div>
                  <span class="text">难度系数 :</span>
                  <span class="value">3</span>
                </div>

                <div>
                  <span class="text">已测评人次 :</span>
                  <span class="value">{{item.testCount}}</span>
                </div>

                <div>
                  <span class="text">平均分 :</span>
                  <span class="value">{{item.aveScore}}</span>
                </div>

                <div class="last"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="no-content">暂无数据~</p>
        </div>
      </div>
      <div class="bottom">
        <topic-page  @currentChange="getPaperListByKnowledgeId" :page-index="current_page" :total-count="pagination.total"></topic-page>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import topicPage from '@/components/page/index'
import high_school_subjcet from "@/assets/js/subject-data.js";
// import stroe from "store"
export default {
  name: "paper-list",
  components : {
      topicPage
    },
  data() {
    return {
      //根据学科动态加载数据
      tab: 1,
      //分页相关
      pagination: {},
      loading: true,
      current_page: 1,
      //渲染数据
      mouseoverId: 0,
      knowledgeId : 0,
      nav_id : 0,
      data: [],
      gkType : '',
      defaultProps: {},
      paperLoading : false
    };
  },
  computed: {
    subjects() {
      let hss = high_school_subjcet;
      let user_json = localStorage.getItem("userinfo");
      let user = JSON.parse(user_json);
      let usi = user.subjectIds.split(",");
      let subjects_obj = {};
      //i为键值

      for (var i in hss) {
        //j为数组索引
        for (var j in usi) {
          let val;
          if (i == usi[j]) {
            val = hss[i];
            subjects_obj[i] = val;
          }
        }
      }
      this.tab = Object.keys(subjects_obj)[0];
      return subjects_obj;
    }
  },
  methods: {
    clickTab(tab) {
      this.tab = tab;
      this.getKnowledgePoint();
      this.getPaperListByKnowledgeId(1);
    },
    getPaperListByKnowledgeId(pageIndex) {
      this.paperLoading = true;
      this.current_page = pageIndex;
      let data = {
        "navigation_id":this.nav_id,
        // "navigation_id":1404,
        "pageIndex":pageIndex,
        "pageSize":5,
      };
      this.$HTTP
        .executePost(this.$APIS.GET_PAPERS_BY_NAV_ID, data, this)
        .then(response => {
          if (response.msg == "Success!") {
            this.pagination = response.data;
            this.paperLoading = false;
          }else{
            this.$message('获取试卷信息失败!');
            this.paperLoading = false;
          }
        });
    },
    //鼠标移动
    mouseOver(id) {
      this.mouseoverId = id;
    },
    mouseOut() {
      this.mouseoverId = 0;
    },
    //分页插件函数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getPaperListByKnowledgeId(val);
    },
    toPaper(id) {
      let app_id = this.$route.query.app_id;
      this.$router.push({
        path: "/paper/paper",
        query: {
          'paper_id': id,
          'app_id' : app_id
        }
      });
    },
    handleNodeClick(data){
      this.nav_id = data.id;
      this.getPaperListByKnowledgeId(1);
    },//获得左侧的树
    async getKnowledgePoint(){
      let userInfo = window.localStorage.getItem('userinfo');
      let user = JSON.parse(userInfo);
      let gk_type = user.gk_type;
      let data = {
        'subject_id' : this.tab,
        'gk_type' : 'GKEL'
      }
      
      await this.$HTTP.executePost(this.$APIS.GET_TREE_BY_GK_TYPE,data,this).then(res=>{
      if(res.code == 0){
        this.data = this.common.createErlunTreeview(res);
        this.nav_id = this.data[0].id;
      }else{
        this.$message("请求知识点目录失败!");
      }
    });
    },
   
  },
  mounted() {
    //在页面初始化时,根据第一个学科查询知识点列表
    //this.getKnowledgePoint();
    this.getKnowledgePoint();
    
    this.getPaperListByKnowledgeId(1);

  },
  created() {
    // this.$nextTick(() => {
    //   this.getPaperListBySubjectId(1);
    // });
  }
};
</script>

<style lang="stylus" scoped>
.paper_list_content {
  width: 1920px;
  height: 965px;
  position: absolute;
  font-family: Microsoft YaHei;

  .container {
    width: 1920px;
    height: 863px;
    margin-top: 72px;
    position: absolute;
    background-color: #efefef;

    .el_header {
      width: 1920px;
      height: 129px;
      float: left;
      background-color: #ffffff;

      .bread {
        width: 1920px;
        height: 57px;
        line-height: 55px;
        font-size: 20px;

        .first {
          margin-left: 178.5px;
        }

        span {
          color: #5c307d;
          float: left;
          cursor: pointer;
        }
      }

      .tabs {
        width: 1920px;
        height: 72px;
        text-align: center;
        background-color: #efefef;
        line-height: 72px;
        float: left;
        border-bottom-width: 4px;
        border-bottom-style: solid;
        border-bottom-color: #d8d8d8;

        .first_tab {
          color: #585858;
          font-size: 20px;
          width: 420px;
          text-align: right;
          height: 72px;
          line-height: 72px;
        }

        div {
          color: #585858;
          font-size: 20px;
          float: left;
          width: 96px;
          margin-left: 76px;
          cursor: pointer;
          height: 72px;
          line-height: 72px;
        }

        .selected_tab {
          color: #585858;
          font-size: 20px;
          float: left;
          line-height: 72px;
          height: 72px;
          width: 96px;
          margin-left: 96px;
          color: #5c307d;
          background-color: #ffffff;
          border-bottom-width: 4px;
          border-bottom-style: solid;
          border-bottom-color: #5c307d;
          cursor: pointer;
        }
      }
    }

    .left {
      width: 400px;
      height: 649px;
      margin-top: 168px;
      margin-left: 178.5px;
      position: absolute;
      ::-webkit-scrollbar {
        width: 0 !important;
      }
      ::-webkit-scrollbar {
        width: 0 !important;height: 0;
      }
      .bar {
        width: 400px;
        height: 50px;
        background-color: #5c307d;
        color: #ffffff;
        font-size: 22px;
        text-align: center;
        line-height: 50px;
      }

      .tree {
        width: auto;
        height: 599px;
        background-color: #ffffff;
          &>>> .el-tree{
            margin-left : 10px;
            width: auto;
            height : 599px;
            overflow-y : auto;
            overflow-x : auto;
            .el-tree-node{
              width : auto !important ;
              .el-tree-node__content{
                color : #585858;
                height : auto;
                width: auto;
                margin : 0;
              }
              .el-tree-node{
                white-space: break-spaces !important;
              }
            }
           
            .el-tree-node__expand-icon{
              cursor: pointer;
              color: #5c307d;
              font-size: 24px;
              -webkit-transform: rotate(0);
              -ms-transform: rotate(0);
              transform: rotate(0);
              -webkit-transition: -webkit-transform .3s ease-in-out;
              transition: -webkit-transform .3s ease-in-out;
              -o-transition: transform .3s ease-in-out;
              transition: transform .3s ease-in-out;
              transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;
              transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
            }
            .el-icon-caret-right{
              cursor: pointer;
              color: #5c307d;
              font-size: 24px;
              -webkit-transform: rotate(0);
              -ms-transform: rotate(0);
              transform: rotate(0);
              -webkit-transition: -webkit-transform .3s ease-in-out;
              transition: -webkit-transform .3s ease-in-out;
              -o-transition: transform .3s ease-in-out;
              transition: transform .3s ease-in-out;
              transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;
              transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
            }
            .expanded{
              -webkit-transform: rotate(90deg);
              -ms-transform: rotate(90deg);
              transform: rotate(90deg);
            }
            .is-leaf{
              color: transparent;
              cursor: default;
            }
            .el-tree-node__label{
              font-size : 14px;
            }
            .el-tree-node__children{
              width : auto !important ;
              overflow : visible !important;
            }
          } 
      }

    }

    .main {
      width: 1090px;
      height: 600px;
      margin-top: 168px;
      margin-left: 612px;
      position: absolute;
      .no-content{
        width: 1090px;
        text-align: center;
        margin-top: 80px;
      }
      .test_paper {
        width: 1129.5px;
        height: 109px;
        float: left;
        font-size: 16px;
        border-radius: 100px;
        background-color: #ffffff;
        margin-top: 10px;
        cursor: pointer;

        .mouseout_paper_number {
          height: 88px;
          width: 88px;
          background-color: #efefef;
          border-radius: 500px;
          float: left;
          margin-top: 10px;
          margin-left: 12.5px;
          text-align: center;
          line-height: 88px;
          color: #5c307d;
          font-size: 18px;
        }

        .mouseover_paper_number {
          height: 88px;
          width: 88px;
          background-color: #5c307d;
          border-radius: 500px;
          float: left;
          margin-top: 10px;
          margin-left: 12.5px;
          text-align: center;
          line-height: 88px;
          color: #efefef;
          font-size: 18px;
        }

        .middle {
          width: 966.5px;
          height: 109px;
          float: left;
          position: relative;
          margin-left: 20px;

          .paper_name {
            width: 966.5px;
            height: 54.5px;
            float: left;
            line-height: 54.5px;
            font-size: 18px;
          }

          .paper_info {
            width: 966.5px;
            height: 54.5px;
            float: left;
            position: relative;
            top: 19.5px;

            .paper_orgin {
              float: left;
              position: relative;
              text-align: left;
              height: 100%;
              width: 300px;
            }

            div {
              float: left;
              position: relative;
              text-align: left;
              height: 100%;
              width: 133px;
            }

            .text {
              height: 100%;
              font-size: 14px;
              color: #585858;
              float: left;
              line-height: 14px;
              
            }

            .value {
              height: 100%;
              float: left;
              color: #585858;
              font-size: 14px;
              line-height: 14px;
              text-align: left;
            }

            .source {
              height: 100%;
              float: left;
              color: #585858;
              font-size: 14px;
              width: 200px;
              line-height: 14px;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }

        .last {
          width: 57px;
        }
      }
    }

    .bottom {
      width: 1090px;
      height: 64px;
      top: 790px;
      margin-left : 612px;
      position: absolute;

      >>> .el-pagination__rightwrapper{
        float : left;
        margin-left : 190px;
        margin-top : -45px;
      }
    }
  }
}
</style>